import { render, staticRenderFns } from "./ModalErroTransferencia.vue?vue&type=template&id=df1e57c0&scoped=true"
import script from "./ModalErroTransferencia.vue?vue&type=script&lang=js"
export * from "./ModalErroTransferencia.vue?vue&type=script&lang=js"
import style0 from "./ModalErroTransferencia.vue?vue&type=style&index=0&id=df1e57c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1e57c0",
  null
  
)

export default component.exports